module.exports = __webpack_public_path__ + "static/media/WI2@2x.86299f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WI/WI2@2x.png
// module id = 739
// module chunks = 0